/* slider bindings*/
var applyMediaBoxSlider = function () {
    $.each($('.bxslider'), function () {
        $(this).show().bxSlider({
            minSlides: $(this).data('min-slides') || 4,
            maxSlides: $(this).data('max-slides') || 5,
            slideWidth: $(this).data('bx-width') || 215,
            slideMargin: 10,
            adaptiveHeight: true,
            preloadImages: 'visible',
            nextText: '<span class="fas fa-caret-right primary fa-4x"></span>',
            prevText: '<span class="fas fa-caret-left primary fa-4x"></span>',
            //auto: true,
            pager: $.hasData(this, 'pager') ? $(this).data('pager') : ($('li', this).length > ($(this).data('max-slides') || 4))
        });
        $('a', this).attr("data-fancybox-group", "fancy-productImageSlider").addClass("fancy-productImageSlider");
    });
};

// init slider first time
applyMediaBoxSlider();

// reinit after translator submits it's contents
$(document).on('translatorContentReloaded', '.mediaBoxContainer', function (e) {
    applyMediaBoxSlider();
});